import React, { Component } from 'react';

export default function withContext(Consumer) {
  return function addContext(WrappedComponent) {
    // eslint-disable-next-line react/prefer-stateless-function
    return class WithContext extends Component {
      render() {
        return (
          <Consumer>
            {context => (
              <WrappedComponent {...this.props} context={{ ...context }} />
            )}
          </Consumer>
        );
      }
    };
  };
}
